<script>
import CourseSectionsComponent from '../features/boxes/CourseSectionsComponent';
import CourseSubjectsView from './CourseSubjectsView';

export default {
  components: {
    'course-subjects-view': CourseSubjectsView,
  },
  extends: CourseSectionsComponent,
};
</script>

<template>
  <el-collapse
    v-loading="isContentLoading"
    class="ui-accordion ui-widget ui-helper-reset boxe-course-section"
  >
    <el-collapse-item
      v-for="(section, sectionIndex) in orderSections(
        courseDetails.courseSections
      )"
      :key="sectionIndex"
      :name="sectionIndex"
    >
      <template #title>
        <el-col
          :xs="18"
          :sm="18"
          :md="18"
          :lg="20"
          :xl="20"
        >
          <div class="title-h3">
            <i class="uil uil-meeting-board" />
            {{ section.title }}
          </div>
        </el-col>
        <!--
        <el-col :xs="6" :sm="12" :md="4" :lg="2" :xl="2" align="center">
          {{ section.getTotalCourseSubjects() }} Temas
        </el-col>
        -->
        <el-col
          :xs="6"
          :sm="6"
          :md="4"
          :lg="2"
          :xl="2"
          align="center"
        >
          {{ section.getDuration() }}
        </el-col>
      </template>
      <course-subjects-view :section="section" />
    </el-collapse-item>
  </el-collapse>
</template>
